/**
 * The brass fallback lock screen, in-SPA (front-door-impl §11). The twin of the
 * statically-served /offline.html — same calm, human, house-brass copy. Shown
 * when the SPA is up but the hub's API is unreachable.
 */
export default function OfflinePage() {
  return (
    <div className="mx-auto flex min-h-full max-w-sm flex-col items-center justify-center gap-5 px-6 py-12 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full border-2 border-brass font-display text-2xl text-brass-deep">
        C
      </div>
      <h1 className="font-display text-[22px] text-ink">The front door is catching its breath.</h1>
      <p className="max-w-xs text-sm text-ink-soft">
        This isn't you — the hub is briefly offline. Your Angels at home keep working without it. Try again in a
        moment.
      </p>
    </div>
  );
}
